import React from 'react';
import Carousel from 'nuka-carousel';

class BannerPrincipal extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            img1: '',
            url1: '',
            img2: '',
            url2: '',
            img3: '',
            url3: '',
        };
        this.handleClickImg1 = this.handleClickImg1.bind(this);
        this.handleClickImg2 = this.handleClickImg2.bind(this);
        this.handleClickImg3 = this.handleClickImg3.bind(this);
    }

    componentWillMount(){
        fetch('/api/uip/imagenes/carousel', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    img1: response[0].imagen,
                    img2: response[1].imagen,
                    img3: response[2].imagen,
                    url1: response[0].url,
                    url2: response[1].url,
                    url3: response[2].url,
                });
                
            })
            .catch(response => console.log(response))
    }

    handleClickImg1(){
        window.open(this.state.url1, "_blank")
    }
    handleClickImg2(){
        window.open(this.state.url2, "_blank")
    }
    handleClickImg3(){
        window.open(this.state.url3, "_blank")
    }

    render(){
        return(
            <Carousel 
                autoplay={true}
                autoplayInterval={6500} 
                wrapAround={true}
                defaultControlsConfig={{
                    nextButtonText: '>',
                    prevButtonText: '<',
                    pagingDotsStyle: {
                    fill: 'white'
                    }
                }}
                >
                <img 
                    src={this.state.img1} 
                    onClick={this.handleClickImg1}/>
                <img 
                    src={this.state.img2} 
                    onClick={this.handleClickImg2}/>
                <img 
                    src={this.state.img3}
                    onClick={this.handleClickImg3} />
            </Carousel>
        );
    }
}

export default BannerPrincipal;